export default function CDefineConstants() {
  return <h2>C Define Constants</h2>;
}
